import { NEUTRAL_100 } from "../../styles/colors"
import styled from "styled-components"

type EditIconContainerProps = {
    $size?: number;
    $backgroundColor?: string;
    $borderColor?: string;
    $borderWidth?: number;
}

// Cast to avoid ts(2883) portability error caused by @types/react version
// mismatch between packages/ui and other packages in the monorepo.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const IconContainer = (styled.div<EditIconContainerProps>`
    width: ${({ $size = 32 }) => `${$size}px`};
    height: ${({ $size = 32 }) => `${$size}px`};
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 100%;
    background-color: ${({ $backgroundColor }) => $backgroundColor || 'transparent'};
    border: ${({ $borderWidth = 1 }) => `${$borderWidth}px solid`} ${({ $borderColor }) => $borderColor || NEUTRAL_100};
`) as any; // eslint-disable-line @typescript-eslint/no-explicit-any
